import React, { Component } from 'react'
import { checkTranslation, translate } from '../utils/useful'

class TemplatesData extends Component {

    state = {
        open: false
    }

    componentDidMount() {
        // console.log('dataaaaaassa', this.props.data)
    }

    render() {

        let data = this.props.data
        // let link = this.props.settings?.baseUrl + '/' + (data.key ?? data._id)
        let name = (data.title ?? data.name) ?? translate("No Name")
        return (
            <button className="w-100 template-box flexcc flex-column h-100 px-2 py-2" onClick={() => this.props.onClick(data.key ?? data._id)}>
                <div className="flexc px-2 w-100">
                    <div style={{ display: 'inline-block', }}>
                        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 2.5a1 1 0 0 1 1-1h12.865a5.24 5.24 0 0 1 3.631 1.447A4.848 4.848 0 0 1 21.5 6.441V21.5a1 1 0 0 1-1 1H7.635a5.24 5.24 0 0 1-3.63-1.447A4.849 4.849 0 0 1 2.5 17.559V2.5Z" fill="#8D55ED"></path><path d="M7.5 7a1 1 0 0 0 0 2h1a1 1 0 1 0 0-2h-1Zm5 0a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-5 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1Zm5 0a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-6 5a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z" fill="#fff"></path></svg>
                    </div>
                    <p className="" style={{ marginLeft: '6px', fontSize: '15px', lineHeight: '24px', fontWeight: 500, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', flex: '1 1 0%' }}>{checkTranslation(name)}</p>
                </div>

                <div className="w-100 m-0 p-0 flexcc pt-3">
                    <div className="m-0 p-0 w-100 h-100 flexcc ">
                        <img className=" m-0 p-0" src={data.img ?? '/assets/icons/applets/general/play-games.png'} alt={data.title} height={200} style={{ aspectRatio: '42/59.4' }} />
                    </div>
                </div>
                <div className='template-box-buttons flexcb pt-2 br-10 w-90'>
                    <button className='template-box-button-preview px-2 py-2 w-100 mrd-2' onClick={() => { this.props.changePreview(this.props.index, data) }}>
                        <p>Preview</p>
                    </button>
                    <button className='template-box-button-use px-2 py-2 w-100 mld-2'>
                        <p>Use</p>
                    </button>
                </div>
            </button>
        )
    }
}

export default TemplatesData
